import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["photosContainer"]

  show(e) {
    const input = e.target;
    const files = input.files;
    if (!files || files.length === 0) return;

    // Pour l'avatar utilisateur, on ne prend que le premier fichier
    const file = files[0];
    const reader = new FileReader();

    reader.onload = (event) => {
      // Vider le conteneur existant
      this.photosContainerTarget.innerHTML = '';
      
      // Créer le nouvel avatar
      const avatarDiv = document.createElement('div');
      avatarDiv.className = 'w-24 h-24 bg-gray-200 rounded-full overflow-hidden';

      const imgElement = document.createElement('img');
      imgElement.src = event.target.result;
      imgElement.className = 'w-full h-full object-cover';

      avatarDiv.appendChild(imgElement);
      this.photosContainerTarget.appendChild(avatarDiv);
    };

    reader.readAsDataURL(file);
  }
}
